export default __webpack_public_path__ + "static/media/G0005.9d191216.png";